import React from "react";

export default class ChevronSteps extends React.Component {
  static defaultProps = {
    stepCount: 5,
    renderStepContent: (stepNum) => "Step " + stepNum,
    onStepClick: null,
    activeStep: 1,
    isStepDisabled: null,
  };

  constructor(props) {
    super(props);
    this.state = {
       hoverStep: null
    }
  }

  renderSteps = () => {
    const steps = [];
    let {stepCount, activeStep, onStepClick, renderStepContent, isStepDisabled} = this.props;

    for (let i = 1; i <= stepCount; i++) {
      const disabled = isStepDisabled ? isStepDisabled(i) : false;
      steps.push(
        <div
          key={i}
          className={`
          chevron  
          
          ${(activeStep === i || this.state.hoverStep === i) ? "active" : ""}
          ${onStepClick && !disabled ? 'is-clickable' : ''}
          ${disabled ? 'disabled' : ''}
          `}
          onMouseOver={(e) => !!onStepClick && !disabled && this.setState({hoverStep: i})}
          onMouseOut={(e) => !!onStepClick && !disabled && this.setState({hoverStep: null})}
          onClick={(e) => !!onStepClick && !disabled && onStepClick(i)}
        >
          <div className="chevron-content">
            {this.props.renderStepContent(i)}
          </div>
        </div>
      );
    }

    return steps;
  };

  render() {
    return (
      <div className="chevron-wrapper only-desktop">
        <div className="is-flex is-flex-wrap-nowrap">
          {this.renderSteps()}
        </div>
      </div>
    );
  }
}
